import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../Firebase";
import { collection, getDocs } from "firebase/firestore";
import {
  FiVideo,
  FiActivity,
  FiArrowRight,
  FiFileText,
  FiClock,
} from "react-icons/fi";
import "./BlogPage.css";

const BlogPage = () => {
  const navigate = useNavigate();
  const [blogsList, setBlogsList] = useState([]);
  const [filter, setFilter] = useState("All");

  // Fetch from Firestore
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "blogs"));
        if (!querySnapshot.empty) {
          const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setBlogsList(list);
        }
      } catch (err) {
        console.error("Error fetching blogs from Firestore: ", err);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <div className="blog-page-wrapper">
      {/* Header Banner */}
      <header
        className="blog-header"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(10, 36, 34, 0.52) 0%, rgba(10, 36, 34, 0.62) 100%), url(${process.env.PUBLIC_URL}/assets/images/img10.jpg)`,
        }}
      >
        <div className="blog-header-overlay" />
        <div className="blog-header-content">
          <h1>Health Blog & Resources</h1>
          <p>
            Read expert health articles, wellness tips and medical information from Swarup Hospital to help you make informed healthcare decisions.
          </p>
        </div>
      </header>

      {/* Filter Bar */}
      <div
        className="blog-filter-bar"
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "15px",
          padding: "30px 20px 0",
        }}
      >
        {["All", "Blogs", "Case Studies", "Services"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: "10px 20px",
              borderRadius: "30px",
              border: "none",
              background: filter === f ? "var(--color-primary)" : "#e2e8f0",
              color: filter === f ? "#fff" : "#475569",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          >
            {f}
          </button>
        ))}
      </div>

      {/* Premium Blog Grid */}
      {blogsList.length === 0 && (
        <div style={{ padding: "60px", textAlign: "center", color: "#64748b" }}>
          <div style={{ fontSize: "2rem", marginBottom: "10px" }}>⏳</div>
          <p>Loading articles...</p>
        </div>
      )}
      <div className="blog-grid-container">
        {blogsList
          .filter((post) => {
            if (filter === "All") return true;
            if (filter === "Blogs")
              return (
                post.type === "Article" ||
                post.type === "Blog" ||
                post.type === "Guide" ||
                post.category === "Blogs"
              );
            if (filter === "Case Studies")
              return (
                post.type === "Case Study" ||
                post.category === "Case Studies" ||
                post.category === "Case Study"
              );
            if (filter === "Services")
              return (
                post.category === "Services" ||
                post.type === "Service" ||
                post.category === "Service"
              );
            return true;
          })
          .map((post) => (
            <article
              key={post.id}
              className="blog-post-card"
              onClick={() => navigate(`/blog/${post.id}`)}
            >
              <div className="blog-card-image-box">
                <img
                  src={post.image}
                  alt={post.title}
                  className="blog-card-image"
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
                <span className="blog-card-badge">{post.category}</span>
              </div>
              <div className="blog-content">
                <div className="blog-post-meta">
                  <span className="meta-tag-type">{post.type}</span>
                  <span className="meta-dot">•</span>
                  <span className="meta-tag-time">
                    <FiClock
                      style={{ marginRight: "4px", verticalAlign: "middle" }}
                    />{" "}
                    {post.readTime}
                  </span>
                </div>
                <h3 className="blog-post-title">{post.title}</h3>
                <p className="blog-post-short-desc">{post.description}</p>
                <button className="read-more-btn">
                  Read Article <FiArrowRight className="btn-arrow" />
                </button>
              </div>
            </article>
          ))}
      </div>

      {/* GEO Resource Library Features */}
      <section className="resources-section">
        <div className="section-header">
          <span className="section-tag">Patient Education</span>
          <h2 className="section-title">Library of Support</h2>
          <p className="section-subtitle">
            A growing collection of educational materials curated by our
            specialists to empower your wellness journey.
          </p>
        </div>
        <div className="resources-grid">
          <div className="resource-item">
            <div className="resource-icon-circle">
              <FiFileText className="resource-icon" />
            </div>
            <h4>Medical Guides</h4>
            <p>
              Condition overviews and surgery preparation details written in
              plain, friendly language.
            </p>
          </div>
          <div className="resource-item">
            <div className="resource-icon-circle">
              <FiActivity className="resource-icon" />
            </div>
            <h4>Healthy Living Tips</h4>
            <p>
              Expert clinical advice on preventative nutrition, joint exercises,
              and heart health metrics.
            </p>
          </div>
          <div className="resource-item">
            <div className="resource-icon-circle">
              <FiVideo className="resource-icon" />
            </div>
            <h4>Interactive Materials</h4>
            <p>
              Short guidelines covering pediatric care, wellness routines, and
              symptom checkups.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
